<script lang="ts">
    import type { PageSegment } from './Segments.types';

    interface Props {
        segment: PageSegment | undefined;
        currentOffset: number;
        paginate: (offset: number) => void;
    }

    let { segment, currentOffset, paginate }: Props = $props();

    const isCurrentOffset = $derived(segment?.offset === currentOffset);
</script>

{#if segment}
    <!-- Keep the current/page data-qa selectors stable: Team Minerva relies on them. -->
    <li
        class="reptile-segment-page__item"
        data-qa={isCurrentOffset ? 'reptile-paging-current' : `reptile-paging-page-${segment.pageNumber}`}
    >
        <button
            disabled={isCurrentOffset}
            class={['reptile-segment-page__button', isCurrentOffset && 'reptile-segment-page__button--current']}
            onclick={() => paginate(segment.offset)}>{segment.pageNumber}</button
        >
    </li>
{/if}

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';
    @use '@shared/styles/colors';

    .reptile-segment-page {
        &__item {
            float: left;
            min-width: 30px;
            font-weight: normal;
            text-align: center;
        }

        &__button {
            cursor: pointer;

            display: block;

            box-sizing: border-box;
            width: 100%;
            min-height: 30px;
            margin-top: 0;
            margin-bottom: 0;
            padding: tokens.$oc-base-dimension-8 10px;
            border: medium none;
            border-radius: 3px;

            font-family: var(--oc-base-font-otto-sans), sans-serif;
            font-size: 0.75rem;
            font-weight: 400;
            line-height: 1.5em;
            color: colors.$reptile-color-black;
            text-align: center;
            text-decoration: none;

            background: none;
            background-clip: padding-box;
            outline: 0 none;

            -webkit-tap-highlight-color: rgb(0 0 0 / 0%);

            &:hover:not(.reptile-bottom-paging__button--current) {
                color: colors.$reptile-color-red-2;
                background: colors.$reptile-color-gray-light;
            }

            &--current {
                font-weight: bold;
                color: colors.$reptile-color-red;
            }
        }
    }
</style>
